import RatingsAndReviews from "../sites/siteDetail/RatingsAndReviews";

/**
 * @function RatingsAndReviewsView
 * @description Standalone Ratings and Reviews page (no siteId filter)
 * @returns JSX for Ratings and Reviews
 */
const RatingsAndReviewsView = () => {
  return <RatingsAndReviews withContainer={false} showSiteColumn={true} />;
};

export default RatingsAndReviewsView;
